import { useState, useCallback } from "react"
import classNames from "classnames"
import { Button, IconButton } from "@mui/material"
import { Add, FirstPage, LastPage } from "@mui/icons-material"
import AiTeammateThreadsList from "connected-components/ai-teammate/components/threads-list"
import { useThreadsContext } from "connected-components/ai-teammate/hooks/context"

export default function ChatSidePanel() {
  // Session-local for this slice; cross-session persistence is a deferred follow-up.
  const [expanded, setExpanded] = useState(true)
  const { newThread, threadId } = useThreadsContext()
  const toggle = useCallback(() => setExpanded((value) => !value), [])
  const label = expanded ? "Collapse conversations" : "Expand conversations"
  // No open thread means we're in a new chat — highlight the New chat control.
  const isNewChat = !threadId

  return <aside className={`agent-chat-side-panel${expanded ? "" : " collapsed"}`}>
    <div className="panel-top">
      <IconButton className="collapse-toggle" onClick={toggle} aria-expanded={expanded} aria-label={label} title={label} size="small">
        {expanded ? <FirstPage /> : <LastPage />}
      </IconButton>
      {expanded
        ? <Button className={classNames("new-chat-button", { active: isNewChat })} variant="text" startIcon={<Add />} onClick={newThread}>New chat</Button>
        : <IconButton className={classNames("new-chat-icon", { active: isNewChat })} onClick={newThread} aria-label="New chat" title="New chat" size="small"><Add /></IconButton>}
    </div>
    {expanded && <AiTeammateThreadsList title="Recents" showNewChatButton={false} showFetchingProgress={false} showUpdatedAt={false} />}
  </aside>
}
